import { render } from "./CallbacksAuthenticationView.vue?vue&type=template&id=ecf4737a&scoped=true"
import script from "./CallbacksAuthenticationView.vue?vue&type=script&lang=js"
export * from "./CallbacksAuthenticationView.vue?vue&type=script&lang=js"

import "./CallbacksAuthenticationView.vue?vue&type=style&index=0&id=ecf4737a&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf4737a"]])

export default __exports__